import type { Descendant } from 'slate';

import { EditorParser } from '@zoomit/primitives';

import RenderElement from './RenderElement';
import RenderLeaf from './RenderLeaf';

type Props = {
  data: Descendant[];
  id?: string;
};

const EditorParserWithElementAndLeaf = (props: Props) => {
  const { data, id } = props;

  // // TODO: refactor after mapper removed
  // const finalData = useMemo(() => {
  //   const dataWithHardBreak = data.map((item: any) => {
  //     const childCount = item.children?.length;

  //     return {
  //       ...item,
  //       children: item.children?.map((item: any, i: number) => {
  //         return {
  //           ...item,
  //           hardBreak: childCount > 1 ? i === childCount - 1 : true,
  //         };
  //       }),
  //     };
  //   });

  //   const [first, ...rest] = dataWithHardBreak;
  //   const modifiedData = rest?.reduce(
  //     (acc, item: any) => {
  //       acc.children = acc.children.concat(item.children);
  //       return acc;
  //     },
  //     JSON.parse(JSON.stringify(first)),
  //   );

  //   return data.length > 1 && data.every((item) => item.type === 'paragraph') ? [modifiedData] : data;
  // }, [data]);

  return (
    <EditorParser
      renderLeaf={(props) => <RenderLeaf {...props}>{props.children}</RenderLeaf>}
      renderElement={(el) => RenderElement({ ...el, id })}
      value={data}
    />
  );
};

export default EditorParserWithElementAndLeaf;
